import React                    from 'react';
import { Observe }              from 'rewire-core';
import {
  WithStyle,
  FormView
}                               from 'rewire-ui';
import { Theme }                from '@material-ui/core/styles';
import DraggableResizableDialog from '../ui/DraggableResizableDialog';
import renameAreaDialogModel    from './RenameAreaDialogModel';
import { withStyles }           from '../utility/styles';

const styles = (_theme: Theme) => ({
});

interface IRenameAreaDialogProps {
}

type RenameAreaDialogProps = WithStyle<ReturnType<typeof styles>, IRenameAreaDialogProps>;

class RenameAreaDialog extends React.PureComponent<RenameAreaDialogProps> {
  constructor(props: RenameAreaDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    renameAreaDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={renameAreaDialogModel.form} onSubmit={renameAreaDialogModel.actionFn('save')}>
        <div className='content'>
          <renameAreaDialogModel.form.field.name.Editor className='span1' />
        </div>
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: renameAreaDialogModel}} DraggableResizableBoxProps={{minWidth: '250px', minHeight: '213px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IRenameAreaDialogProps>(styles, RenameAreaDialog);
